import { Badge } from '@mantine/core';

export function TestBadge({ size = 'sm' }: { size?: string }) {
  return (
    <Badge size={size} color="grape" variant="light">
      Test
    </Badge>
  );
}
